// src/ArrowRight.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ArrowRight_default = createIcon({
  displayName: "ArrowRight",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M14 5C13.7441 5 13.488 5.09942 13.293 5.29492L13.207 5.38086C12.816 5.77186 12.816 6.40492 13.207 6.79492L17.0703 10.6582H4C3.448 10.6582 3 11.1062 3 11.6582C3 12.2102 3.448 12.6582 4 12.6582H17.0703L13.207 16.5215C12.816 16.9125 12.816 17.5455 13.207 17.9355L13.293 18.0215C13.684 18.4125 14.317 18.4125 14.707 18.0215L20.3633 12.3652C20.7543 11.9742 20.7543 11.3412 20.3633 10.9512L14.707 5.29492C14.5115 5.09942 14.2559 5 14 5Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  ArrowRight_default
};
